import React from 'react';
import { Formik, FieldArray } from 'formik';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useDuplicateProjectTagMutation, mainActions } from '../../store';
import { Modal } from '../../components';
import { QuickAlert } from '../../components';

export const DuplicateTagModal = (props) => {
    const { show, onClose, projectId, tag } = props;
    const [duplicateProjectTag] = useDuplicateProjectTagMutation();
    const dispatch = useDispatch();

    const defaultTagValues = {
        value: tag.value,
        room: tag.room,
        equipmentType: tag.equipmentType,
        trade: tag.trade,
    };

    const handleSubmit = async (values, formikHelpers) => {
        dispatch(
            mainActions.showWaitingModal({
                isSimple: true,
                msg: 'Duplicating tag and its product(s)....',
            }),
        );
        formikHelpers.setSubmitting(false);
        onClose();
        try {
            await duplicateProjectTag({
                id: projectId,
                tagId: tag.id,
                tags: values.tags[0],
            }).unwrap();
        } catch (err) {
            console.log(err);
        } finally {
            dispatch(mainActions.hideWaitingModal());
        }
    };

    const handleValidate = (values) => {
        let errors = {};
        return errors;
    };

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="sm:container p-4">
                <h1>Tag</h1>
                <div>
                    <Formik
                        initialValues={{ tags: [defaultTagValues] }}
                        validate={handleValidate}
                        onSubmit={handleSubmit}
                    >
                        {(formik) => (
                            <form onSubmit={formik.handleSubmit}>
                                {Object.keys(formik.errors ?? {}).map(
                                    (k) =>
                                        formik.touched?.[k] && (
                                            <QuickAlert
                                                key={k}
                                                kind="error"
                                                msg={formik.errors?.[k]}
                                            />
                                        ),
                                )}
                                <FieldArray name="tags">
                                    {(tagsHelpers) => (
                                        <div className="mb-4">
                                            {formik.values.tags.map(
                                                (row, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="flex justify-between gap-4 mb-2"
                                                    >
                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags.${idx}.value`}
                                                            >
                                                                Tag
                                                            </label>
                                                            <div className="swegon-ui-text-input-wrapper">
                                                                <input
                                                                    type="text"
                                                                    name={`tags.${idx}.value`}
                                                                    onChange={
                                                                        formik.handleChange
                                                                    }
                                                                    value={
                                                                        row.value
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags.${idx}.equipmentType`}
                                                            >
                                                                Equipment Type
                                                            </label>
                                                            <div className="swegon-ui-text-input-wrapper">
                                                                <input
                                                                    type="text"
                                                                    name={`tags.${idx}.equipmentType`}
                                                                    onChange={
                                                                        formik.handleChange
                                                                    }
                                                                    value={
                                                                        row.equipmentType
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags.${idx}.room`}
                                                            >
                                                                Room
                                                            </label>
                                                            <div className="swegon-ui-text-input-wrapper">
                                                                <input
                                                                    type="text"
                                                                    name={`tags.${idx}.room`}
                                                                    onChange={
                                                                        formik.handleChange
                                                                    }
                                                                    value={
                                                                        row.room
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags.${idx}.trade`}
                                                            >
                                                                Trade
                                                            </label>
                                                            <div className="swegon-ui-text-input-wrapper">
                                                                <input
                                                                    type="text"
                                                                    name={`tags.${idx}.trade`}
                                                                    onChange={
                                                                        formik.handleChange
                                                                    }
                                                                    value={
                                                                        row.trade
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ),
                                            )}
                                        </div>
                                    )}
                                </FieldArray>
                                <div className="flex justify-end">
                                    <button
                                        onClick={onClose}
                                        type="button"
                                        className="swegon-like-button outlined mr-4 !px-4 amber"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="swegon-like-button contained"
                                        type="submit"
                                        disabled={formik.isSubmitting}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    );
};
